import React from "react";
// 2026-07-05 (operator : "fix the spinner too") : the loading state
// previously rendered <span className="loading loading-spinner
// loading-sm"> - DaisyUI-style classes of which only .loading-spinner
// exists in this project (an animation rule with no size or content),
// so the "spinner" was an invisible empty spacer in both themes since
// the component was written. Replaced with the real shared
// LoadingSpinner SVG. SECOND ROUND (PR #82 review 4883064183 RED
// finding) : the first replacement was STILL invisible on the primary
// variant because .loading-spinner hardcoded text-blue-600, making
// currentColor resolve to blue-on-blue on .btn-primary. The color is
// now removed from the shared class entirely, so the svg inherits the
// BUTTON's text color : white on primary, blue on outline : correct
// in every variant and both themes by construction, and the
// regression test pins the absence of the hardcoded blue.
import LoadingSpinner from "./LoadingSpinner";

/**
 * Standardized action button component for consistent sizing across all tools
 */
export default function ActionButton({
  onClick,
  loading = false,
  disabled = false,
  variant = "primary", // primary, outline, success, danger
  icon: Icon,
  loadingText = "Processing...",
  children,
  fullWidth = false,
  className = "",
  ...props
}) {
  const baseClasses =
    "btn btn-lg min-w-[200px] sm:min-w-[240px] lg:min-w-[280px] h-auto min-h-[48px] px-4 sm:px-6 py-3 whitespace-normal";

  const variantClasses = {
    primary: "btn-primary",
    outline: "btn-outline",
    success: "btn-success",
    danger: "btn-error",
  };

  const widthClass = fullWidth ? "w-full" : "";

  const classes = `${baseClasses} ${variantClasses[variant]} ${widthClass} ${className}`;

  return (
    <button
      onClick={onClick}
      disabled={disabled || loading}
      className={classes}
      {...props}
    >
      {loading ? (
        <>
          <LoadingSpinner size="sm" className="mr-2" />
          {loadingText}
        </>
      ) : (
        <>
          {Icon && <Icon className="w-5 h-5 mr-2" />}
          {children}
        </>
      )}
    </button>
  );
}
